import Client from "./Clients/AxiosClient";
const base = "/api/v1/user";

export default {
  getPtn(search) {
    return Client.get(`${base}/ptn`, {
      params: { search, page_size: 9999 },
    });
  },
  getProdi(ptnId, search) {
    return Client.get(`${base}/prodi`, {
      params: { ptn_id: ptnId, search, page_size: 9999 },
    });
  },
  getProdiDetail(id) {
    return Client.get(`${base}/prodi/${id}`);
  },
};
